// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".configurator-image-row[data-v-518f1e46]{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:6px}.option[data-v-518f1e46]{text-align:center;width:90px}.option[data-v-518f1e46] img{border-radius:4px;height:50px;margin-top:5px;width:67px}.option .caption[data-v-518f1e46]{font-size:13px;padding:5px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
